import { Component, Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import templateContent from "../../_shark_templates/components/main-nav.html";

import applicatorTeamListView from "../views/applicatorTeamListView.js";
import clientListView from "../../views/contacts-and-leads/clientListView";
import constructionSiteCardListView from "../../views/constructionSite/constructionSiteCardListView";
import constructionSiteListView from "../../views/constructionSite/constructionSiteListView";
import { documentListView } from "../../views/documents/documentListView";
import { globalReportsView } from "../../views/global-report/globalReportsView.js";
import { homeView } from "../views/homeView";
import leadListView from "../../views/contacts-and-leads/leadListView.js";
import loginView from "../../views/login/loginView";
import { notComplianceReportListView } from "../../views/constructionSite/notComplianceReportListView";
import quotationListView from "../views/quotationListView";
import siteInfoSheetListView from "../../views/site-info-sheets/siteInfoSheetListView";
import userListView from "../../views/users/userListView";
import userProfileView from "../../views/users/userProfileView";
import visitListView from "../../views/visits/visitListView";
import sampleRequestListView from "../../views/sample-requests/sampleRequestListView";

class MainNavComponent extends Component {
	constructor () {
		super("mainNavComponent");
		this.addTemplate("", templateContent);
	}

	beforeRender () {
		const currUser = Shark.get("currUser");
		let userRoles = currUser.roles;
		let userIsSellRepresentativeOnly = false;
		userIsSellRepresentativeOnly = userRoles.length === 1 && (userRoles.indexOf("sellRepresentative") !== -1);

		const siteInfoSheetList = Shark.get("siteInfoSheetList");

		this.set({
			currUser: currUser,
			showThinHeader: ["loginView", "homeView"].indexOf(Shark.activePage.id) === -1,
			userIsSellRepresentativeOnly: userIsSellRepresentativeOnly,
			__applicatorTeamListViewActive: ["applicatorTeamEditView", "applicatorTeamListView"].includes(Shark.activePage.id),
			__clientPageActive: ["clientListView", "clientEditView"].includes(Shark.activePage.id),
			__constructionSiteViewActive: ["constructionSiteEditView", "constructionSiteListView"].includes(Shark.activePage.id),
			__constructionSiteCardViewActive: ["constructionSiteCardEditView", "constructionSiteCardListView"].includes(Shark.activePage.id),
			__documentsPageActive: Shark.activePage.id === "documentListView",
			__hideMenu: ["loginView", "registrationView"].includes(Shark.activePage.id),
			__homePageActive: Shark.activePage.id === "homeView",
			__notComplianceReportViewActive: ["notComplianceReportEditView", "notComplianceReportListView"].includes(Shark.activePage.id),
			__prospectPageActive: ["leadDetailsView", "leadImportView", "leadListView"].includes(Shark.activePage.id),
			__quotationViewActive: ["quotationEditView", "quotationListView"].includes(Shark.activePage.id),
			__sheetPageActive: ["siteInfoSheetDisplayView", "siteInfoSheetListView", "siteInfoSheetOutdoorEditView", "siteInfoSheetOutdoorDisplayView", "siteInfoSheetEditView"].includes(Shark.activePage.id),
			__siteInfoSheetCount: siteInfoSheetList ? siteInfoSheetList.length : 0,
			__userPageActive: ["userEditView", "userListView"].includes(Shark.activePage.id),
			__visitPageActive: ["visitEditView", "visitListView"].includes(Shark.activePage.id),
			__sampleRequestPageActive: ["sampleRequestListView"].includes(Shark.activePage.id),

			__showSiteInfoSheetVoice: currUser.hasPermission(["manageClientSolvencyRequest", "manageSiteInfoSheet", "viewSiteInfoSheet"]),// || currUser.hasPermission("viewSiteInfoSheet"),
			__showQuotationVoice: currUser.hasPermission("manageQuotation") || currUser.hasPermission("viewQuotation"),
			__showConstructionSiteVoice: currUser.hasPermission("manageConstructionSite") || currUser.hasPermission("viewConstructionSites"),
			__showConstructionSiteCardVoice: currUser.hasPermission("manageConstructionSiteCard") || currUser.hasPermission("viewConstructionSiteCard"),
			__showNotComplianceReportVoice: currUser.hasPermission("editNotComplianceReportForIPM") || currUser.hasPermission("viewNotComplianceReport"),
			__showVisitVoice: currUser.hasPermission("manageClientVisits") || currUser.hasPermission("viewVisits"),
		});
	}

	clientBtn_clickHandler () {
		Shark.openPage(clientListView);
	}

	documentBtn_clickHandler () {
		Shark.openPage(documentListView);
	}

	homeBtn_clickHandler () {
		Shark.openPage(homeView);
	}

	logoutBtn_clickHandler () {
		NousCore.api.abandonSession()
		.then(() => {
			localStorage.removeItem("preserveLogin");
			Shark.set("__loginError", "");
			Shark.openPage(loginView);
		});
	}

	navApplicatorTeamListViewBtn_clickHandler () {
		Shark.openPage(applicatorTeamListView);
	}

	navConstructionSiteBtn_clickHandler () {
		Shark.openPage(constructionSiteListView);
	}

	navConstructionSiteCardBtn_clickHandler () {
		Shark.openPage(constructionSiteCardListView);
	}

	navGlobalReportsViewBtn_clickHandler () {
		Shark.openPage(globalReportsView);
	}

	navNotComplianceReportBtn_clickHandler () {
		Shark.set({currConstructionSite: null});
		Shark.openPage(notComplianceReportListView);
	}

	navProspectBtn_clickHandler () {
		Shark.set("forceProspectListRefresh", true);
		Shark.openPage(leadListView);
	}

	navQuotationBtn_clickHandler () {
		Shark.openPage(quotationListView);
	}

	navSampleRequestBtn_clickHandler () {
		Shark.openPage(sampleRequestListView);
	}

	navVistiListViewBtn_clickHandler () {
		Shark.openPage(visitListView);
	}

	sheetBtn_clickHandler () {
		Shark.openPage(siteInfoSheetListView);
	}

	userBtn_clickHandler () {
		Shark.openPage(userListView);
	}

	userProfileBtn_clickHandler () {
		Shark.openPage(userProfileView);
	}
}

const mainNavComponent = new MainNavComponent();

Shark.registerComponent(mainNavComponent);

export default mainNavComponent;
